import { formatISO } from 'date-fns';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IdNamePair } from '../../types/globalTypes';
import { MaterialBasicDetails } from '../../types';

interface MaterialState {
  basicVendors: Array<IdNamePair>;
  lastFetchedVendorsOn: string | null;
  scannedMaterialMapping: Record<string | number, MaterialBasicDetails>;
  lastFetchedScannedMaterialMappingOn: string | null;
}

const initialState: MaterialState = {
  basicVendors: [],
  lastFetchedVendorsOn: null,
  scannedMaterialMapping: {},
  lastFetchedScannedMaterialMappingOn: null,
};

interface ScannedMaterialMappingPayload {
  scannedMaterial: string | number;
  results: MaterialBasicDetails;
}

type CachedType = 'basicVendors' | 'scannedMaterialMapping';

const Materials = createSlice({
  name: 'Materials',
  initialState,
  reducers: {
    getVendors(state, action: PayloadAction<Array<IdNamePair>>) {
      state.basicVendors = action.payload;
      state.lastFetchedVendorsOn = formatISO(new Date());
    },
    setScannedMaterialMapping(
      state,
      action: PayloadAction<ScannedMaterialMappingPayload>,
    ) {
      state.scannedMaterialMapping[action.payload.scannedMaterial] =
        action.payload.results;
      state.lastFetchedScannedMaterialMappingOn = formatISO(new Date());
    },
    invalidateMaterialCache(state, action: PayloadAction<CachedType>) {
      switch (action.payload) {
        case 'scannedMaterialMapping':
          state.lastFetchedScannedMaterialMappingOn = null;
          state.scannedMaterialMapping = {};
          break;
        case 'basicVendors':
          state.lastFetchedVendorsOn = null;
          state.basicVendors = [];
          break;
      }
    },
  },
});

export const {
  getVendors,
  setScannedMaterialMapping,
  invalidateMaterialCache,
} = Materials.actions;

export const MaterialsReducer = Materials.reducer;
